import { render, staticRenderFns } from "./HomeHeading.vue?vue&type=template&id=5f7f4771&scoped=true&"
import script from "./HomeHeading.vue?vue&type=script&lang=ts&"
export * from "./HomeHeading.vue?vue&type=script&lang=ts&"
import style0 from "./HomeHeading.vue?vue&type=style&index=0&id=5f7f4771&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7f4771",
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QIcon});
